/**
 * A controlled React Native input does not necessarily redraw when a
 * sanitised value is equal to the previous React state. For example, when the
 * field already holds `1234` and a pasted value is `1234abc`, React correctly
 * keeps state at `1234` but can leave the native buffer showing `1234abc`.
 *
 * That is particularly unsafe for an odometer: the number the person sees
 * must be the exact number that will be sent with the inspection. Synchronise
 * the native buffer on rejected characters as well as returning the canonical
 * value for state.
 */
export type NativeTextSynchronizer = {
  setNativeProps: (props: { text: string }) => void
}

export function sanitizeOdometerText(
  text: string,
  nativeInput?: NativeTextSynchronizer | null,
): string {
  const digits = text.replace(/[^0-9]/g, '')
  if (digits !== text) {
    nativeInput?.setNativeProps({ text: digits })
  }
  return digits
}
